import mutations from "./mutations";
import * as actions from "./actions";
import * as getters from "./getters";

// state
let state = {
    plans: null
}

export default {mutations, actions, state, getters}


// WEBPACK FOOTER //
// ./src/store/modules/subscription/index.js